
import LayoutMixin from '@/mixins/layout'
import station from '@/modules/site'

export default {
  mixins: [LayoutMixin],
  asyncData({ route }) {
    const {
      params: { site },
    } = route
    return {
      site,
    }
  },
  computed: {
    comp() {
      return station[this.site].product
    },
  },
}
